export default "__VITE_ASSET__Bfe5$VW1__"